/**
 * Stap 3: het gesprek met de personages en met Socrates.
 *
 * Wat er gezegd wordt staat in hooks/useGesprek.js (het scherm houdt het
 * gesprek vast, omdat de leerlingen heen en weer gaan naar de argumenten).
 * Hier staan de opmaak, de lijst links, de berichten en het invoerveld.
 */
import React from 'react';
import { Send } from 'lucide-react';
import { kleur } from '../../../theme/tokens';
import { basis } from '../stijlen';
import { GroepBadge, Tijdklok, PersonaBeeld } from '../onderdelen/GroepEnKlok';
import { ChatZijbalk } from '../onderdelen/ChatZijbalk';
import { ChatBerichten } from '../onderdelen/ChatBerichten';

export function Chat({ apiUrl, session, discussion, groepje, discussieleider, gesprek, klok, onNaarArgumenten }) {
  const bijToets = (e) => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); gesprek.stuur(); } };

  return (
    <div style={styles.chatContainer}>
      <div style={styles.chatHeader}>
        <GroepBadge groepje={groepje} discussion={discussion} />
        <Tijdklok seconden={klok.seconden} />
        <div style={styles.stellingMini}>De stelling: {session.statement?.titel}</div>
        <button onClick={onNaarArgumenten} style={styles.btnSmall}>Argumenten</button>
      </div>
      <div style={styles.chatLayout}>
        <ChatZijbalk apiUrl={apiUrl} discussieleider={discussieleider} personas={discussion.personas}
          activePersona={gesprek.activePersona} onKies={gesprek.setActivePersona} reflectieFase={klok.reflectieFase} />

        <div style={styles.chatMain}>
          <ChatBerichten berichten={gesprek.berichten} bezig={gesprek.bezig}
            activePersona={gesprek.activePersona} onVraagUitleg={gesprek.vraagUitleg} />

          <div style={styles.chatInput}>
            <div style={styles.inputLabel}>
              {gesprek.activePersona && (
                <span style={styles.inputLabelPortret}><PersonaBeeld apiUrl={apiUrl} persona={gesprek.activePersona} grootte={28} /></span>
              )}
              Vraag aan: <strong>{gesprek.activePersona?.naam || 'Kies een persoon'}</strong>
            </div>
            <div style={styles.inputRow}>
              <textarea value={gesprek.invoer} onChange={(e) => gesprek.setInvoer(e.target.value)} onKeyPress={bijToets}
                placeholder="Typ je bericht..." style={styles.textarea} rows={2} disabled={!gesprek.activePersona} />
              <button onClick={gesprek.stuur} disabled={gesprek.bezig || !gesprek.invoer.trim() || !gesprek.activePersona} style={styles.sendBtn}><Send size={20} /></button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const styles = {
  ...basis,
  chatContainer: { background: 'white', overflow: 'hidden' },
  chatHeader: { padding: '16px 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '12px' },
  stellingMini: { fontSize: '14px', color: kleur.stil, flex: 1, textAlign: 'center' },
  btnSmall: { padding: '8px 16px', background: kleur.accent, color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '14px' },
  chatLayout: { display: 'grid', gridTemplateColumns: '250px 1fr', minHeight: '500px' },
  chatMain: { display: 'flex', flexDirection: 'column' },
  chatInput: { padding: '16px', borderTop: `1px solid ${kleur.lijn}` },
  inputLabel: { fontSize: '13px', color: kleur.stil, marginBottom: '8px' },
  inputLabelPortret: { display: 'inline-block', verticalAlign: 'middle', marginRight: '8px' },
  inputRow: { display: 'flex', gap: '12px' },
  textarea: { flex: 1, padding: '12px', border: `2px solid ${kleur.lijn}`, borderRadius: '8px', fontSize: '14px', resize: 'none' },
  sendBtn: { padding: '12px 20px', background: kleur.accent, color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '18px' },
};
